import { debounce } from 'lodash-es';
import mediator from './mediator';
import { updateConfig } from './util/config';
import getScreenProperties from './util/screen';
export var addScrollHandler = function addScrollHandler() {
  // Adds a global window:throttledScroll event to mediator, which debounces events
  // until the user has stopped scrolling the window for a reasonable amount of time.
  var onScroll = function onScroll(evt) {
    mediator.emitEvent('window:throttledScroll', [evt]);
  };

  window.addEventListener('scroll', debounce(onScroll, 200), {
    passive: true
  });
};
export var addResizeHandler = function addResizeHandler() {
  var updateScreenProperties = function updateScreenProperties() {
    return updateConfig({
      screen: getScreenProperties()
    });
  }; // Adds a global window:throttledResize event to mediator, which debounces events
  // until the user has stopped resizing the window for a reasonable amount of time.
  // Also updates detects some screen properties and updates the event object with those.


  var onResize = function onResize(evt) {
    var _updateScreenProperti = updateScreenProperties(),
        screen = _updateScreenProperti.screen;

    evt.screen = screen;
    mediator.emitEvent('window:throttledResize', [evt]);
  };

  window.addEventListener('resize', debounce(onResize, 200), {
    passive: true
  });
  window.addEventListener('orientationchange', debounce(onResize, 200), {
    passive: true
  });
  updateScreenProperties();
};
export var addErrorHandler = function addErrorHandler() {
  var addGA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  if (addGA) {
    // eslint-disable-next-line
    window.addEventListener('error', window.__e = function f(e) {
      f.q = f.q || [];
      f.q.push(e);
    });
  }

  window.addEventListener('unhandledrejection', function (evt) {
    evt.preventDefault();
    console.group('Unhandled promise rejection');
    console.log('Promise', evt.promise);
    console.log('Reason', evt.reason);
    console.groupEnd();
  });
};
export var addLoadHandler = function addLoadHandler() {
  window.addEventListener('load', function () {
    return updateConfig({
      loaded: true
    });
  });
};
export default (function () {
  addLoadHandler();
  addScrollHandler();
  addResizeHandler();
  addErrorHandler();
});